import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { checkLoggedUser, getUser } from '../../../redux/usersRedux';
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Alert,
} from '@mui/material';
import { Link } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  getSpecifications,
  loadSpecificationsRequest,
} from '../../../redux/specificationRedux';

const SpecificationListForm = ({ action, link }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const specifications = useSelector((state) => getSpecifications(state));
  const user = useSelector((state) => getUser(state));

  useEffect(() => {
    let mounted = true;

    const start = async () => {
      try {
        setLoading(true);
        setError(null);

        await Promise.all([
          dispatch(loadSpecificationsRequest()),
          dispatch(checkLoggedUser()),
        ]);
      } catch (e) {
        if (mounted) setError(e?.message || 'Błąd wczytywania danych');
      } finally {
        if (mounted) setLoading(false);
      }
    };

    start();
    return () => {
      mounted = false;
    };
  }, [dispatch]);

  const handleSubmit = (id) => action(id);

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: 240,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error">
        {t('common.error')}: {error}
      </Alert>
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="reason table">
        <TableHead>
          <TableRow>
            <TableCell>{t('masterData.specification.description')}</TableCell>
            <TableCell>{t('masterData.specification.unit')}</TableCell>
            <TableCell>{t('masterData.specification.decisionMaker')}</TableCell>

            {user?.users?.role === 'ADMIN' && (
              <TableCell align="center">{t('account.action')}</TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {specifications?.map((el) => (
            <TableRow
              key={el.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th">{el.name}</TableCell>
              <TableCell>{el.unit}</TableCell>
              <TableCell>{el.decisionMaker}</TableCell>

              {user?.users?.role === 'ADMIN' ? (
                <TableCell>
                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      sx={{ color: 'orange' }}
                      component={Link}
                      to={`/${link}/${el.id}`}
                    >
                      <EditIcon />
                    </Button>
                    <Button
                      sx={{ color: 'red' }}
                      onClick={() => handleSubmit(el.id)}
                    >
                      <DeleteIcon />
                    </Button>
                  </Box>
                </TableCell>
              ) : null}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SpecificationListForm;
